import { Users } from './users.model';

export class Approver {
  contractsApproverId: number = 0
  tenantId: number = null
  contractId: number = 0
  approverId: number = 0
  status: number = 0
  description: String = null
  sequenceNo: number = null
  userInfo: Users = new Users
  createdBy: String = null
  createdDate: Date = new Date()
  updatedBy: String = null
  updatedDate: Date = new Date()
}
